"use strict";
var Model = require("../types/Model");

module.exports = Model({
	name: "orguserinvites",
	init: init,
	uninit: uninit,
	triggers: triggers,
	listeners: listeners,
});

function init(){
	this._tracker = this.dispatcher.createTracker();
	this._viewing = false;
	this._orgGroup = null;
	this.push([]);
}

function uninit(){
	this._tracker.off();
	this._tracker = null;
}

function triggers(){
	return {
		view: view,
		cancel: cancel
	};
}

function listeners(){
	return {
		"orggroup:updated": handle_orggroup_update
	};
}

function view(){
	this._viewing = true;
	return Promise.all([this.api.org.users.invitation.list(), this.api.org.users.invitation.list_existing()])
		.then(resolves => {
			return resolves.reduce((acc, cur) => acc.concat(cur), []);
		}).then(handle_list.bind(this))
		.then(trackChanges.bind(this));
}

function handle_list(list){
	this.push(list);
}

function handle_orggroup_update(orgGroup){
	if(!orgGroup) return;
	this._orgGroup = orgGroup;
}

function trackChanges(){
	var tracker = this._tracker;
	var orgGroup = this._orgGroup;
	var viewing = this._viewing;

	if(!orgGroup || !viewing) return;

	tracker.off();
	tracker.on("mqtt:orggroup/" + orgGroup + "/users/invite/new", addInvite.bind(this));
	tracker.on("mqtt:orggroup/" + orgGroup + "/users/invite/used", removeInvite.bind(this));
	tracker.on("mqtt:orggroup/" + orgGroup + "/users/invite/removed", removeInvite.bind(this));
}

function addInvite(invite){
	var list = this.data;
	var newList = list.concat(invite);
	this.push(newList);
}

function removeInvite(data){
	var id = data._id;
	var list = this.data;
	var newList = list.filter(function(invite){
		return invite._id !== id;
	});
	this.push(newList);
}

function cancel(id){
	return Promise.allSettled([
		this.api.org.users.invitation.remove(id),
		this.api.org.users.invitation.remove_existing(id)
	])
	.then(results => {
		this.emit("usermetrics:trigger:track", "cancel email request", {who: id});
		return results
			.filter(result => result.status === "fulfilled")
			.map(result => result.value);
	});
}